import { IOmniaSession } from "../../types"

const refreshButtonKey = "refreshButton"

// TODO: those should be deleted, at some point
const disabledKeys = [
    "fieldsLoaderV3"
]

export function getTestSettings(session: IOmniaSession) {

    const prod = session.production

    const settings = session.getSettings("tests")

    return {

        get showRefreshButton() {
            return settings.get(refreshButtonKey, !prod)
        },

        toggleRefreshButton() {
            settings.set(refreshButtonKey, !this.showRefreshButton)
        },

    }
}
